import { OPPORTUNITY_EFFECTS, OPPORTUNITY_SERVICES, OpportunityFeatureKey, OpportunityReducer, UISharedModule } from '@accuservpro/xplat/features';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OPPORTUNITY_COMPONENTS } from './components';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    UISharedModule,
    NgbPaginationModule,
    StoreModule.forFeature(OpportunityFeatureKey, OpportunityReducer),
    EffectsModule.forFeature(OPPORTUNITY_EFFECTS),
  ],
  declarations: [...OPPORTUNITY_COMPONENTS],
  exports: [...OPPORTUNITY_COMPONENTS],
  providers: [...OPPORTUNITY_SERVICES],
})
export class WebOpportunityModule {}
